import { reactive } from 'vue'

// Global notification state
const notificationState = reactive({
  show: false,
  type: 'success', // success, error, warning, info
  title: '',
  message: '',
  details: '',
  copyText: null
})

export const useNotifications = () => {
  const showNotification = (type, title, message, details = '', copyText = null) => {
    notificationState.show = true
    notificationState.type = type
    notificationState.title = title
    notificationState.message = message
    notificationState.details = details
    notificationState.copyText = copyText
  }

  const closeNotification = () => {
    notificationState.show = false
    setTimeout(() => {
      notificationState.type = 'success'
      notificationState.title = ''
      notificationState.message = ''
      notificationState.details = ''
      notificationState.copyText = null
    }, 300) // Wait for exit animation
  }

  const showSuccess = (title, message, details = '') => {
    showNotification('success', title, message, details)
  }

  const showError = (title, message, details = '') => {
    showNotification('error', title, message, details)
  }

  const showWarning = (title, message, details = '') => {
    showNotification('warning', title, message, details)
  }

  const showInfo = (title, message, details = '') => {
    showNotification('info', title, message, details)
  }

  return {
    notification: notificationState,
    showNotification,
    closeNotification,
    showSuccess,
    showError,
    showWarning,
    showInfo
  }
}